"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumFontMapper = void 0;
const altiumValidation_1 = require("../../../altiumValidation");
class AltiumFontMapper {
    static { this.RasterSizeCorrection = 1.1; }
    constructor(projectDef) {
        this.schematicFontMap = new Map();
        this.projectFonts = new Map();
        this.fontKeyToId = new Map();
        for (const [fileName, schematicDef] of Object.entries(projectDef.schematics)) {
            if (!schematicDef.validationResult?.isValid) {
                continue;
            }
            const schematic = schematicDef.validationResult.data.metadata[altiumValidation_1.AltiumProjectMetadataKey.SchDoc];
            const sheet = schematic.getSheet();
            const localFontMap = new Map();
            const fonts = sheet.getFonts();
            for (const [localFontId, fontInfo] of fonts.entries()) {
                const projectFontId = this.getOrCreateProjectFont(fontInfo);
                localFontMap.set(localFontId, projectFontId);
            }
            this.schematicFontMap.set(fileName, localFontMap);
        }
    }
    getOrCreateProjectFont(fontInfo) {
        const fontKey = this.createFontKey(fontInfo);
        const keyString = this.fontKeyToString(fontKey);
        const existingId = this.fontKeyToId.get(keyString);
        if (existingId) {
            return existingId;
        }
        const fontId = this.generateFontId(fontKey);
        const browserFont = this.createBrowserFont(fontInfo);
        this.fontKeyToId.set(keyString, fontId);
        this.projectFonts.set(fontId, browserFont);
        return fontId;
    }
    createFontKey(fontInfo) {
        return {
            fontName: fontInfo.fontName,
            size: fontInfo.size,
            bold: fontInfo.bold ?? false,
            italic: fontInfo.italic ?? false,
        };
    }
    fontKeyToString(key) {
        return `${key.fontName}|${key.size}|${key.bold}|${key.italic}`;
    }
    generateFontId(key) {
        let baseName = key.fontName.replace(/\s+/g, '_');
        if (key.bold) {
            baseName += '_Bold';
        }
        if (key.italic) {
            baseName += '_Italic';
        }
        const sizeStr = `_${key.size.toFixed(2)}mm`;
        baseName += sizeStr;
        let fontId = baseName;
        let counter = 1;
        while (this.projectFonts.has(fontId)) {
            fontId = `${baseName}_${counter}`;
            counter++;
        }
        return fontId;
    }
    createBrowserFont(fontInfo) {
        const attrs = fontInfo.textOpts.attr;
        return {
            type: 'browser',
            name: fontInfo.fontName,
            size: fontInfo.size,
            rasterSizeCorrection: AltiumFontMapper.RasterSizeCorrection,
            attrs: attrs && attrs.length > 0 ? attrs : undefined,
        };
    }
}
exports.AltiumFontMapper = AltiumFontMapper;
//# sourceMappingURL=AltiumFontMapper.js.map